<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索简称..."
          @on-change="searchBankAccount"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 20px"
        >
        </Input>
        <Select
          placeholder="筛选公司"
          v-model="company"
          label-in-value
          clearable
          @on-change="choseCompany"
          style="width: 220px; margin-right: 30px"
        >
          <Option
            v-for="item in companyList"
            :value="item._id"
            :key="item._id"
          >{{ item.name }}</Option>
        </Select>
      </div>
      <div class="handle-right">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="15"
          @on-change="loadBill"
          show-total
          simple
          style="margin-right: 24px"
        />
        <Button
          type="primary"
          @click="openAddBillDrawer()"
        >新增票据</Button>
      </div>
    </div>
    <div
      class="table-wrapper"
      ref="tableWrapper"
    >
      <Table
        :columns="columns"
        :data="billList"
        :height="tableHeight"
      > </Table>
    </div>
    <AddBillDrawer ref="AddBillDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import AddBillDrawer from "./AddBillDrawer";
import _ from "lodash";
import dayjs from "dayjs";

const billStatusText = {
  waiting: "未到期",
  receive: "到期收款",
  overdue: "逾期无法兑现",
  paid: "背书给供应商",
  partPaid: "部分支付",
};
const billTypeText = {
  bankAccBill: "银承",
  commAccBill: "商承",
  check: "支票",
  yun: "云信通",
  jian: "建信融通",
  bankAccBillPaper: "纸质银承",
  gold: "金单",
  sywx: "商银微芯",
  ji: "集信",
  zhu: "筑信",
};
const tagsText = {
  heimingdan: "黑名单",
  ketiexian: "可贴现",
  "6+9": "6+9",
};
export default {
  name: "BillPage",
  components: { AddBillDrawer },
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      digit: 0,
      columns: [
        {
          title: "汇票状态",
          minWidth: 80,
          key: "billStatus",
          align: "left",
          render: (h, params) =>
            h("span", billStatusText[params.row.billStatus]),
        },
        {
          title: "出票银行",
          minWidth: 160,
          key: "billBank",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
              params.row.billBank
            ),
        },
        {
          title: "票据类型",
          minWidth: 80,
          key: "type",
          align: "left",
          render: (h, params) => h("span", billTypeText[params.row.type]),
        },
        {
          title: "客户",
          minWidth: 180,
          key: "customer",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    cursor: "pointer",
                    color: "#42b983",
                  },
                  on: {
                    click: () => {
                      this.$refs.AddBillDrawer.openDrawer(params.row, "edit");
                    },
                  },
                },
                params.row.paidByCustomer ? params.row.paidByCustomer.name : ""
              ),
            ]);
          },
        },
        {
          title: "公司",
          key: "company",
          minWidth: 80,
          align: "left",
          render: (h, params) =>
            h(
              "span",
              params.row.company.abbr
                ? params.row.company.abbr
                : params.row.company.name
            ),
        },
        {
          title: "金额",
          key: "amount",
          minWidth: 100,
          align: "right",
          render: (h, params) =>
            h(
              "span",
              params.row.amount ? params.row.amount.toLocaleString() : ""
            ),
        },
        {
          title: "创建人",
          key: "createdBy",
          align: "center",
          minWidth: 110,
          render: (h, params) =>
            h("span", params.row.createdBy ? params.row.createdBy.name : ""),
        },
        {
          title: "备注",
          minWidth: 100,
          key: "remark",
          align: "center",
          render: (h, params) => h("span", params.row.remark),
        },
        {
          title: "标签",
          key: "tags",
          align: "left",
          minWidth: 80,
          render: (h, params) =>
            h(
              "span",
              params.row.tags
                ? params.row.tags.map((x) => tagsText[x]).join(",")
                : ""
            ),
        },
        {
          title: "汇票编号",
          minWidth: 160,
          key: "billNo",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
              params.row.billNo
            ),
        },
        {
          title: "出票公司",
          minWidth: 160,
          key: "billCompany",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
              params.row.billCompany
            ),
        },

        {
          title: "出票日期",
          minWidth: 110,
          key: "billIssuedAt",
          render: (h, params) =>
            h(
              "span",
              params.row.billIssuedAt
                ? dayjs(params.row.billIssuedAt).format("YYYY-MM-DD")
                : ""
            ),
        },
        {
          title: "汇票到期",
          minWidth: 110,
          key: "billEndedAt",
          render: (h, params) =>
            h(
              "span",
              params.row.billEndedAt
                ? dayjs(params.row.billEndedAt).format("YYYY-MM-DD")
                : ""
            ),
        },
      ],
      filterQuery: {},
      limit: 20,
      tableHeight: 300,
      company: null,
    };
  },
  computed: mapState({
    billList: (state) => state.bill.billList,
    totalRows: (state) => state.bill.totalCounts,
    currentUser: (state) => state.auth.currentUser,
    companyList: (state) => state.company.companyList,
  }),
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getBill: "bill/getBillAction",
      getCompanyList: "company/getCompanyListAction",
      getSimpleUserList: "user/getSimpleUserListAction",
    }),
    async loadBill(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText && this.searchText.trim() !== "") {
        this.filterQuery.name = this.searchText;
      } else {
        delete this.filterQuery.name;
      }
      try {
        this.tableLoading = true;
        await this.getBill(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchBankAccount: _.debounce(function () {
      this.page = 0;
      this.loadBill();
    }, 1000),
    async choseCompany(company) {
      if (company) {
        this.filterQuery.company = company.value;
      } else {
        delete this.filterQuery.company;
      }
      await this.loadBill(this.filterQuery);
    },
    openAddBillDrawer() {
      this.$refs.AddBillDrawer.openDrawer();
    },
  },
  async created() {
    this.loadBill();
    await this.getCompanyList({ limit: 99 });
    await this.getSimpleUserList({ limit: 99 });
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.handle-right
  display flex
  align-items center
  justify-content space-between

.table-wrapper
  width 100%
  height calc(100% - 48px)

.button-group
  display flex

.container
  overflow-y auto

.card-content
  display flex
  flex-wrap wrap

.card-item
  margin 0 20px 20px 0

.item
  display flex
  justify-content space-between
</style>
